import { NavLink } from 'react-router-dom'
import './styles/Menu.scss'

import { useContext } from 'react'
import PopupContext from '../context/popupContext'

import Form from './Form'
import MainForm from './MainForm'

import Logo from '../images/Logo--menu.svg'

import { HashLink } from 'react-router-hash-link'

import { GiHamburgerMenu } from "react-icons/gi";

function Menu() {
    const { currentPopup, setCurrentPopup } = useContext(PopupContext)

    const reviewContent = <MainForm />

    const handleBackdropClick = () => {
        setCurrentPopup({ content: currentPopup.content, isActive: false })
        setTimeout(() => {
            setCurrentPopup({ content: '', isActive: false })
        }, 300)
    }

    return (
        <nav>
            <NavLink className={({ isActive }) => (isActive ? 'activeLink' : 'link')} to="/" end onClick={(evt) => {
                    handleBackdropClick()
                }}>
                <img src={Logo} alt="" />
            </NavLink>
            <div className="menu__links">
                <NavLink className={({ isActive }) => (isActive ? 'activeLink' : 'link')} to="/about-us" onClick={(evt) => {
                    handleBackdropClick()
                }}>
                    О нас
                </NavLink>
                <NavLink className={({ isActive }) => (isActive ? 'activeLink' : 'link')} to="/blog" onClick={(evt) => {
                    handleBackdropClick()
                }}>
                    Блог
                </NavLink>
                <HashLink className={({ isActive }) => (isActive ? 'activeLink' : 'link')} to="/#our-products" onClick={(evt) => {
                    handleBackdropClick()
                }}>
                    Услуги
                </HashLink>
                <NavLink className={({ isActive }) => (isActive ? 'activeLink' : 'link')} to="/price" onClick={(evt) => {
                    handleBackdropClick()
                }}>
                    Цены
                </NavLink>
                <NavLink className={({ isActive }) => (isActive ? 'activeLink' : 'link')} to="/clients" onClick={(evt) => {
                    handleBackdropClick()
                }}>
                    Клиенты
                </NavLink>
                <HashLink className={({ isActive }) => (isActive ? 'activeLink' : 'link')} to="/#our-team" onClick={(evt) => {
                    handleBackdropClick()
                }}>
                    Команда
                </HashLink>
                <NavLink className={({ isActive }) => (isActive ? 'activeLink' : 'link')} to="/career" onClick={(evt) => {
                    handleBackdropClick()
                }}>
                    Карьера
                </NavLink>


                <HashLink className={({ isActive }) => (isActive ? 'activeLink' : 'link')} to="/#footer" onClick={(evt) => {
                    handleBackdropClick()
                }}>
                    Контакты
                </HashLink>


            </div>
            <div
                className="link link-demo"
                onClick={(evt) => {
                    setCurrentPopup({ content: reviewContent, isActive: true })
                }}
            >
                Оставить заявку
            </div>
        </nav>
    )
}

export default Menu
